"use client";

import React from "react";
import ArrowUpIcon from "@/assets/svgs/arrow-up.svg";

const FloatingBtn = () => {
  const handleScrollUp = () => {
    window?.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <button
      onClick={handleScrollUp}
      className="ss:fixed ss:bottom-5 ss:cursor-pointer ss:z-10 ss:right-5 ss:w-10 ss:h-10 ss:rounded-full ss:flex ss:items-center ss:justify-center ss:bg-white ss:shadow-xl"
    >
      <ArrowUpIcon className="ss:w-5 ss:h-5" />
    </button>
  );
};

export default FloatingBtn;
